/**
 * Created by jyothi on 22/8/17.
 */

export const RESET_ALL = "RESET_ALL";